// extracted by mini-css-extract-plugin
export default {"actionDiv":"divs-module___actionDiv___a2cbbfac","clickable":"divs-module___clickable___f95fa4eb"};